import I18N from '@leverege/i18n';
import { LinkAction } from "../../../routes/index.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.screens.account.Profile');
export default LinkAction.create({
  id: 'account.link.Profile',
  matches: {
    use: 'navBar',
    client: 'AccountScreen'
  },
  name: tf('name'),
  icon: tfIcon('icon'),
  path: '/account/profile'
});